import React from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Row,
} from "reactstrap";

const SalesStats = ({ summary }) => {
  return (
    <>
      <Row className="mt-4">
        <Col>
          <Card style={{ boxShadow: "0 9px 20px rgba(46, 35, 94, .07)", overflow: "hidden", marginBottom: 15 }}>
            <CardBody style={{ padding: "15px 0px 15px 20px" }}>
              <span style={{ letterSpacing: 0.5, color: "rgba(82, 82, 108, .8)", fontSize: 14 }}>Items Sold</span>
              <div>
                {" "}
                <h4>
                  <span style={{ color: "#212529", fontSize: 20, fontWeight: 500 }}>{summary.totalItemsSold ?? 0}</span>
                </h4>
              </div>
              <div
                style={{
                  fontSize: 30,
                  color: "purple",
                  alignItems: "center",
                  borderRadius: 100,
                  display: "flex",
                  height: 95,
                  justifyContent: "center",
                  position: "absolute",
                  right: -23,
                  top: "50%",
                  "-webkit-transform": "translateY(-50%)",
                  transform: "translateY(-50%)",
                  width: 95,
                  backgroundImage: "linear-gradient(144.16deg, rgba(115, 102, 255, .1) 19.06%, rgba(115, 102, 255, 0) 79.03%)",
                }}
              >
                <i class="fa fa-shopping-cart" aria-hidden="true"></i>
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col>
          <Card style={{ boxShadow: "0 9px 20px rgba(46, 35, 94, .07)", overflow: "hidden", marginBottom: 15 }}>
            <CardBody style={{ padding: "15px 0px 15px 20px" }}>
              <span style={{ letterSpacing: 0.5, color: "rgba(82, 82, 108, .8)", fontSize: 14 }}>Orders</span>
              <div>
                {" "}
                <h4>
                  <span style={{ color: "#212529", fontSize: 20, fontWeight: 500 }}>{summary.totalOrders ?? 0}</span>
                </h4>
              </div>
              <div
                style={{
                  fontSize: 30,
                  color: "#FF7A00",
                  alignItems: "center",
                  borderRadius: 100,
                  display: "flex",
                  height: 95,
                  justifyContent: "center",
                  position: "absolute",
                  right: -23,
                  top: "50%",
                  "-webkit-transform": "translateY(-50%)",
                  transform: "translateY(-50%)",
                  width: 95,
                  backgroundImage: "linear-gradient(144.16deg, rgba(255,122,0,.15) 19.06%, rgba(255,122,0,0) 79.03%)",
                }}
              >
                <i class="fa fa-shopping-bag" aria-hidden="true"></i>
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col>
          <Card style={{ boxShadow: "0 9px 20px rgba(46, 35, 94, .07)", overflow: "hidden", marginBottom: 15 }}>
            <CardBody style={{ padding: "15px 0px 15px 20px" }}>
              <span style={{ letterSpacing: 0.5, color: "rgba(82, 82, 108, .8)", fontSize: 14 }}>Returns</span>
              <div>
                {" "}
                <h4>
                  <span style={{ color: "#212529", fontSize: 20, fontWeight: 500 }}>{summary.totalReturns ?? 0}</span>
                </h4>
              </div>
              <div
                style={{
                  fontSize: 30,
                  color: "#00C9A7",
                  alignItems: "center",
                  borderRadius: 100,
                  display: "flex",
                  height: 95,
                  justifyContent: "center",
                  position: "absolute",
                  right: -23,
                  top: "50%",
                  "-webkit-transform": "translateY(-50%)",
                  transform: "translateY(-50%)",
                  width: 95,
                  backgroundImage: "linear-gradient(144.16deg, rgba(0,201,167,.15) 19.06%, rgba(0,201,167,0) 79.03%)",
                }}
              >
                <i class="fa fa-undo" aria-hidden="true"></i>
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col>
          <Card style={{ boxShadow: "0 9px 20px rgba(46, 35, 94, .07)", overflow: "hidden", marginBottom: 15 }}>
            <CardBody style={{ padding: "15px 0px 15px 20px" }}>
              <span style={{ letterSpacing: 0.5, color: "rgba(82, 82, 108, .8)", fontSize: 14 }}>Customers</span>
              <div>
                {" "}
                <h4>
                  <span style={{ color: "#212529", fontSize: 20, fontWeight: 500 }}>{summary.totalUniqueCustomers ?? 0}</span>
                </h4>
              </div>
              <div
                style={{
                  fontSize: 30,
                  color: "#FF4D6D",
                  alignItems: "center",
                  borderRadius: 100,
                  display: "flex",
                  height: 95,
                  justifyContent: "center",
                  position: "absolute",
                  right: -23,
                  top: "50%",
                  "-webkit-transform": "translateY(-50%)",
                  transform: "translateY(-50%)",
                  width: 95,
                  backgroundImage: "linear-gradient(144.16deg, rgba(255,77,109,.15) 19.06%, rgba(255,77,109,0) 79.03%)",
                }}
              >
                <i class="fa fa-users" aria-hidden="true"></i>
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col>
          <Card style={{ boxShadow: "0 9px 20px rgba(46, 35, 94, .07)", overflow: "hidden", marginBottom: 15 }}>
            <CardBody style={{ padding: "15px 0px 15px 20px" }}>
              <span style={{ letterSpacing: 0.5, color: "rgba(82, 82, 108, .8)", fontSize: 14 }}>Gross Sales</span>
              <div>
                {" "}
                <h4>
                  <span style={{ color: "#212529", fontSize: 20, fontWeight: 500 }}>{`£ ${Number(
                    summary.totalGrossSales ?? 0
                  ).toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</span>
                </h4>
              </div>
              <div
                style={{
                  fontSize: 30,
                  color: "#2ECC71",
                  alignItems: "center",
                  borderRadius: 100,
                  display: "flex",
                  height: 95,
                  justifyContent: "center",
                  position: "absolute",
                  right: -23,
                  top: "50%",
                  "-webkit-transform": "translateY(-50%)",
                  transform: "translateY(-50%)",
                  width: 95,
                  backgroundImage: "linear-gradient(144.16deg, rgba(46,204,113,.15) 19.06%, rgba(46,204,113,0) 79.03%)",
                }}
              >
                <i class="fa fa-usd" aria-hidden="true"></i>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col>
          <Card style={{ boxShadow: "0 9px 20px rgba(46, 35, 94, .07)", overflow: "hidden", marginBottom: 15 }}>
            <CardBody style={{ padding: "15px 0px 15px 20px" }}>
              <span style={{ letterSpacing: 0.5, color: "rgba(82, 82, 108, .8)", fontSize: 14 }}>Net Sales</span>
              <div>
                {" "}
                <h4>
                  <span style={{ color: "#212529", fontSize: 20, fontWeight: 500 }}>{`£ ${Number(
                    summary.totalNetSales ?? 0
                  ).toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</span>
                </h4>
              </div>
              <div
                style={{
                  fontSize: 30,
                  color: "#E67E22",
                  alignItems: "center",
                  borderRadius: 100,
                  display: "flex",
                  height: 95,
                  justifyContent: "center",
                  position: "absolute",
                  right: -23,
                  top: "50%",
                  "-webkit-transform": "translateY(-50%)",
                  transform: "translateY(-50%)",
                  width: 95,
                  backgroundImage: "linear-gradient(144.16deg, rgba(230,126,34,.15) 19.06%, rgba(230,126,34,0) 79.03%)",
                }}
              >
                <i class="fa fa-usd" aria-hidden="true"></i>
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col>
          <Card style={{ boxShadow: "0 9px 20px rgba(46, 35, 94, .07)", overflow: "hidden", marginBottom: 15 }}>
            <CardBody style={{ padding: "15px 0px 15px 20px" }}>
              <span style={{ letterSpacing: 0.5, color: "rgba(82, 82, 108, .8)", fontSize: 14 }}>Average Order Value</span>
              <div>
                {" "}
                <h4>
                  <span style={{ color: "#212529", fontSize: 20, fontWeight: 500 }}>{`£ ${Number(
                    summary.averageOrderValue ?? 0
                  ).toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</span>
                </h4>
              </div>
              <div
                style={{
                  fontSize: 30,
                  color: "#3498DB",
                  alignItems: "center",
                  borderRadius: 100,
                  display: "flex",
                  height: 95,
                  justifyContent: "center",
                  position: "absolute",
                  right: -23,
                  top: "50%",
                  "-webkit-transform": "translateY(-50%)",
                  transform: "translateY(-50%)",
                  width: 95,
                  backgroundImage: "linear-gradient(144.16deg, rgba(52,152,219,.15) 19.06%, rgba(52,152,219,0) 79.03%)",
                }}
              >
                <i class="fa fa-bar-chart" aria-hidden="true"></i>
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col>
          <Card style={{ boxShadow: "0 9px 20px rgba(46, 35, 94, .07)", overflow: "hidden", marginBottom: 15 }}>
            <CardBody style={{ padding: "15px 0px 15px 20px" }}>
              <span style={{ letterSpacing: 0.5, color: "rgba(82, 82, 108, .8)", fontSize: 14 }}>Average Revenue Per Customer</span>
              <div>
                {" "}
                <h4>
                  <span style={{ color: "#212529", fontSize: 20, fontWeight: 500 }}>{`£ ${Number(
                    summary.averageRevenuePerCustomer ?? 0
                  ).toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</span>
                </h4>
              </div>
              <div
                style={{
                  fontSize: 30,
                  color: "#9B59B6",
                  alignItems: "center",
                  borderRadius: 100,
                  display: "flex",
                  height: 95,
                  justifyContent: "center",
                  position: "absolute",
                  right: -23,
                  top: "50%",
                  "-webkit-transform": "translateY(-50%)",
                  transform: "translateY(-50%)",
                  width: 95,
                  backgroundImage: "linear-gradient(144.16deg, rgba(155,89,182,.15) 19.06%, rgba(155,89,182,0) 79.03%)",
                }}
              >
                <i class="fa fa-google-wallet" aria-hidden="true"></i>
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col>
          <Card style={{ boxShadow: "0 9px 20px rgba(46, 35, 94, .07)", overflow: "hidden", marginBottom: 15 }}>
            <CardBody style={{ padding: "15px 0px 15px 20px" }}>
              <span style={{ letterSpacing: 0.5, color: "rgba(82, 82, 108, .8)", fontSize: 14 }}>Repeat Purchase Rate</span>
              <div>
                {" "}
                <h4>
                  <span style={{ color: "#212529", fontSize: 20, fontWeight: 500 }}>{`${Number(
                    summary.repeatPurchaseRate ?? 0
                  )} %`}</span>
                </h4>
              </div>
              <div
                style={{
                  fontSize: 30,
                  color: "#007bff",
                  alignItems: "center",
                  borderRadius: 100,
                  display: "flex",
                  height: 95,
                  justifyContent: "center",
                  position: "absolute",
                  right: -23,
                  top: "50%",
                  "-webkit-transform": "translateY(-50%)",
                  transform: "translateY(-50%)",
                  width: 95,
                  backgroundImage: "linear-gradient(144.16deg, rgba(0, 123, 255, .15) 19.06%, rgba(0, 123, 255, 0) 79.03%)",
                }}
              >
                <i class="fa fa-line-chart" aria-hidden="true"></i>
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col>
          <Card style={{ boxShadow: "0 9px 20px rgba(46, 35, 94, .07)", overflow: "hidden", marginBottom: 15 }}>
            <CardBody style={{ padding: "15px 0px 15px 20px" }}>
              <span style={{ letterSpacing: 0.5, color: "rgba(82, 82, 108, .8)", fontSize: 14 }}>Return Rate</span>
              <div>
                {" "}
                <h4>
                  <span style={{ color: "#212529", fontSize: 20, fontWeight: 500 }}>{`${Number(summary.returnRate ?? 0)} %`}</span>
                </h4>
              </div>
              <div
                style={{
                  fontSize: 30,
                  color: "#e74c3c",
                  alignItems: "center",
                  borderRadius: 100,
                  display: "flex",
                  height: 95,
                  justifyContent: "center",
                  position: "absolute",
                  right: -23,
                  top: "50%",
                  "-webkit-transform": "translateY(-50%)",
                  transform: "translateY(-50%)",
                  width: 95,
                  backgroundImage: "linear-gradient(144.16deg, rgba(231, 76, 60, .15) 19.06%, rgba(231, 76, 60, 0) 79.03%)",
                }}
              >
                <i class="fa fa-cart-arrow-down" aria-hidden="true"></i>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default SalesStats;